import { useAppSelector } from "../../hooks/redux.hook";
import { history } from "../../_config";
import IconButton2 from "../icon-button-2-component";

export function SubscribersCountView() {
  const { community, user } = useAppSelector((state) => {
    return {
      community: state.community,
      user: state.auth,
    };
  });
  if (!user || !community) {
    return <></>;
  } else if (community.myRole !== "admin") {
    return <></>;
  }
  return (
    <IconButton2
      icon="address-book"
      className="text-xl cursor-pointer"
      unreadCount={community.newUserCount}
      onClick={() => {
        history.push("/settings/members");
      }}
    />
  );
}
